import React, { useState, useEffect } from 'react';
import './StatusSelector.css';

const StatusSelector = ({ currentStatus, currentCustomStatus, onStatusChange, onClose }) => {
  console.log('StatusSelector received:', { currentStatus, currentCustomStatus });
  
  const [customStatus, setCustomStatus] = useState(currentCustomStatus || '');
  const [selectedStatus, setSelectedStatus] = useState(currentStatus || 'online');

  // Update local state when props change
  useEffect(() => {
    console.log('StatusSelector useEffect triggered with:', { currentStatus, currentCustomStatus });
    setSelectedStatus(currentStatus || 'online');
    setCustomStatus(currentCustomStatus || '');
  }, [currentStatus, currentCustomStatus]);

  const statuses = [
    { value: 'online', label: 'Online', icon: '🟢' },
    { value: 'away', label: 'Away', icon: '🟡' },
    { value: 'busy', label: 'Busy', icon: '🔴' },
    { value: 'dnd', label: 'Do Not Disturb', icon: '⛔' },
    { value: 'offline', label: 'Invisible', icon: '⚫' }
  ];

  const handleSave = async () => {
    try {
      const response = await fetch('/api/chat/rooms/status', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          status: selectedStatus,
          customStatus
        })
      });

      if (response.ok) {
        onStatusChange(selectedStatus, customStatus);
        onClose();
      }
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  return (
    <div className="status-selector-overlay" onClick={onClose}>
      <div className="status-selector" onClick={(e) => e.stopPropagation()}>
        <div className="selector-header">
          <h3>Set Status</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="status-options">
          {statuses.map(status => (
            <button
              key={status.value}
              className={`status-option ${selectedStatus === status.value ? 'selected' : ''}`}
              onClick={() => setSelectedStatus(status.value)}
            >
              <span className="status-icon">{status.icon}</span>
              <span className="status-label">{status.label}</span>
            </button>
          ))}
        </div>

        <div className="custom-status-input">
          <label>Custom Status (optional)</label>
          <input
            type="text"
            placeholder="What's happening?"
            value={customStatus}
            onChange={(e) => setCustomStatus(e.target.value)}
            maxLength={100}
          />
        </div>

        <button className="save-status-btn" onClick={handleSave}>
          Save Status
        </button>
      </div>
    </div>
  );
};

export default StatusSelector;
